(function navigationTiming(root) {
  'use strict';

  /**
  * @private
  * isValidMetricTime: validates the value passed to be a number greater than 0.
  *
  * @param {object} value to be validated.
   * @returns true if the value is a valid number and greater or equals than zero.
  */
  function isValidMetricTime(value) {
    return !Number.isNaN(value) && value >= 0;
  }

  // Schema object to validate the information that is going to be send to Segment.
  const schema = {
    dns_lookup: isValidMetricTime,
    dom_complete: isValidMetricTime,
    dom_content_loaded: isValidMetricTime,
    dom_interactive: isValidMetricTime,
    page_load: isValidMetricTime,
    render_time: isValidMetricTime,
    tcp: isValidMetricTime,
    ttfb: isValidMetricTime
  };

  /**
   * @private
   * track: Dispatch a new trackOnDemandEvent with the data from the performance navigation.
   */
  function track() {
    requestAnimationFrame(() => {
      const performanceTiming = root.performance.getEntriesByType('navigation')[0];
      if (!performanceTiming) {
        return;
      }
      const eventForSegment = {
        dns_lookup: performanceTiming.domainLookupEnd - performanceTiming.domainLookupStart,
        dom_complete: performanceTiming.domComplete - performanceTiming.responseStart,
        dom_content_loaded: performanceTiming.domContentLoadedEventEnd - performanceTiming.fetchStart,
        dom_interactive: performanceTiming.domInteractive - performanceTiming.responseStart,
        event: 'Performance Metrics',
        eventType: 'segmentEvent',
        page_load: performanceTiming.loadEventEnd - performanceTiming.fetchStart,
        render_time: performanceTiming.domComplete - performanceTiming.domContentLoadedEventEnd,
        tcp: performanceTiming.connectEnd - performanceTiming.connectStart,
        ttfb: performanceTiming.responseStart - performanceTiming.fetchStart
      };

      Object.keys(schema).filter((key) => !schema[key](eventForSegment[key])).forEach((key) => {
        delete eventForSegment[key];
      });

      if (root.analytics) {
        root.document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
          detail: { data: eventForSegment }
        }));
      }
    });
  }

  /**
   * @private
   * delayedTrack: creates a timeout to execute the track function,
   * seTimeout is needed to provide browser time to fill the domContentLoadedEventEnd timing.
   */
  function delayedTrack() {
    setTimeout(track, 500);
  }

  if (root.document.readyState === 'complete') {
    track();
    return;
  }

  root.addEventListener('load', delayedTrack);
}(window));
